<template>
	<div>

		<t-text-area
			height="500px"
			resize="none"
			:value="messageContents"
			disabled
		/>

	</div>
</template>

<script>

export default {
	
	name: 'OriginalMessage',

	props: { ordersAndErrors: Object },
	computed: {
		messageContents() {
			if (!this.ordersAndErrors.error)
				return JSON.stringify(this.ordersAndErrors.originalData, null, 2);
			return  JSON.stringify(this.ordersAndErrors.error, null, 2);
		}
		
		
	}
	
	
};
</script>

<style>

</style>